module.exports = __webpack_public_path__ + "static/media/link-boomer-write.41932d93.png";